import { ButtonGroup, Button } from 'Components/Core';
import { ISelectOption } from 'Components/Core/Dropdown/types';
import { PageSection } from 'Components/Layout';
import { useState } from 'react';
import { IAgsLaboratoriesParams } from '../types';
import AgsExportConfigurationAddLaboratoryDialogAdmin from './AgsExportConfigurationAddLaboratoryDialogAdmin';
import AgsExportConfigurationLaboratoryRowAdmin from './AgsExportConfigurationLaboratoryRowAdmin';

const AgsExportConfigurationLaboratoryAdmin: React.FC<IAgsLaboratoriesParams> = ({
  agsLaboratoryMappings,
  configurations,
  agsDefaultConfigurationMapping,
}) => {
  const [showLaboratoryMappingDialog, setShowLaboratoryMappingDialog] = useState(false);

  const defaultMappingOptions: ISelectOption[] = configurations.map((agsVersion) => ({
    label: 'AGS ' + agsVersion.AgsVersion,
    options: agsVersion.Configurations.map((configuration) => ({
      label: configuration.Name,
      value: configuration.Id,
    })),
  }));

  return (
    <PageSection heading={'Laboratory Settings'}>
      <AgsExportConfigurationLaboratoryRowAdmin
        laboratorySetting={agsDefaultConfigurationMapping}
        selectOptions={defaultMappingOptions}
        key={'AgsLabSetting_' + agsDefaultConfigurationMapping?.LaboratoryUUID}
        isDefaultConfiguration={true}
      />
      {agsLaboratoryMappings.map((row) => (
        <AgsExportConfigurationLaboratoryRowAdmin
          laboratorySetting={row}
          selectOptions={defaultMappingOptions}
          key={'AgsLabSetting_' + row.LaboratoryUUID}
          isDefaultConfiguration={false}
        />
      ))}
      <ButtonGroup>
        <Button
          primary
          onClick={() => {
            setShowLaboratoryMappingDialog(true);
          }}
        >
          Add Laboratory Mapping
        </Button>
      </ButtonGroup>
      <AgsExportConfigurationAddLaboratoryDialogAdmin
        dialogVisibleState={showLaboratoryMappingDialog}
        asgConfigurationListOptions={defaultMappingOptions}
        onClose={() => {
          setShowLaboratoryMappingDialog(false);
        }}
      />
    </PageSection>
  );
};

export default AgsExportConfigurationLaboratoryAdmin;
